exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block; }\n\n.question-container {\n  padding: 0 8px;\n  font-size: 10px; }\n\n.question-number {\n  font-weight: 800;\n  padding: 10px 0 5px 0;\n  font-size: 12px; }\n\n.prompt {\n  padding-bottom: 13px; }\n\n.multi-choice-text {\n  text-align: left;\n  padding: 0 8px 5px 13px; }\n  .multi-choice-text .multi-choice-letter {\n    font-weight: 800;\n    padding-right: 5px; }\n\n.true-false-button-container,\n.multi-choice-button-container {\n  margin-top: 13px;\n  padding-bottom: 24px; }\n\n.multi-choice-button,\n.true-false-button {\n  font-size: 12px;\n  border: solid 1px #555; }\n\n.multi-choice-button {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  line-height: 12px;\n  padding-top: 8.4px;\n  margin: 0 7px;\n  border-radius: 100%; }\n\n.true-false-button {\n  display: block;\n  padding: 5.4px 10px;\n  border-radius: 20px;\n  width: 180px;\n  margin: 0 auto 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/page-preview/question-preview/question-preview.component.scss
// module id = ../../../../../src/app/shared/components/page-preview/question-preview/question-preview.component.scss
// module chunks = 12